import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import arTranslations from './locales/ar.json';

const resources = {
  en: {
    translation: enTranslations
  },
  ar: {
    translation: arTranslations
  }
};

// Check for saved language preference or use Arabic as default
let savedLanguage = localStorage.getItem('language') || 'ar';

// Override with URL ?lang= if present (supports 'en' and 'ar') and persist it
try {
  const params = new URLSearchParams(window.location.search);
  const urlLang = (params.get('lang') || '').toLowerCase();
  if (urlLang === 'en' || urlLang === 'ar') {
    savedLanguage = urlLang;
    localStorage.setItem('language', urlLang);
  }
} catch (e) {
  // ignore errors (e.g., SSR or malformed URL)
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage, // Use saved language or default to Arabic
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;